/**
 * Created by razial on 18.09.2026.
 */

PassLevelsConfig.levelpass = [
    {
        level: 0,
        task: {
            goal: 3
        },
        reward: {
            unlimitedLives: "30 minutes"
        },
        premiumReward: {
            unlimitedLives: "12 hours"
        }
    },
    {
        level: 1,
        task: {
            goal: 5
        },
        reward: {
            boosters: {
                5: 1
            }
        },
        premiumReward: {
            boosters: {
                5: 3
            }
        }
    },
    {
        level: 2,
        task: {
            goal: 8
        },
        reward: {
            unlimitedLives: "1 hour"
        },
        premiumReward: {
            boosters: {
                0: 3
            }
        }
    },
    {
        level: 3,
        task: {
            goal: 12
        },
        reward: {
            boosters: {
                6: 1
            }
        },
        premiumReward: {
            unlimitedLives: "12 hours"
        }
    },
    {
        level: 4,
        task: {
            goal: 15
        },
        reward: {
            unlimitedLives: "2 hours"
        },
        premiumReward: {
            boosters: {
                1: 3
            }
        }
    },
    {
        level: 5,
        task: {
            goal: 20
        },
        reward: {
            exp: 20
        },
        premiumReward: {
            hard: 300
        }
    },
    {
        level: 6,
        task: {
            goal: 25
        },
        reward: {
            boosters: {
                7: 1
            }
        },
        premiumReward: {
            boosters: {
                2: 3
            }
        }
    },
    {
        level: 7,
        task: {
            goal: 30
        },
        reward: {
            boosters: {
                6: 2
            }
        },
        premiumReward: {
            unlimitedLives: "12 hours"
        }
    },
    {
        level: 8,
        task: {
            goal: 40
        },
        reward: {
            unlimitedLives: "2 hours"
        },
        premiumReward: {
            boosters: {
                0: 5
            }
        }
    },
    {
        level: 9,
        task: {
            goal: 50
        },
        reward: {
            boosters: {
                2: 1
            }
        },
        premiumReward: {
            hard: 500
        }
    }
];
